import React from 'react';
import PropTypes from 'prop-types';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { IconCancel } from 'svgIcons/MotionPortalIcons';
import { translate } from 'helpers/translateHelper';

const HierarchyDuplicateNameModal = ({
    isOpen,
    onClose,
    onRename
}) => {
    return (
        <GeneralDialog
            show={isOpen}
            close={onClose}
            title={
                <div className='hierarchy-error-title'>
                    <IconCancel
                        width={22}
                        height={22}
                        showCircle={true}
                        color={'rgb(241, 238, 237)'}
                        fillColor={'rgba(239, 58, 52, 1)'}
                    />
                    <span>{translate('ABB.Powertrain.Frontend.hierarchyDuplicateNameModalTitle')}</span>
                </div>
            }
            modalClassName='hierarchy-error-dialog'
            backdropClassName='hierarchy-error-backdrop'
            cancelButtonProps={{
                text: translate('ABB.Powertrain.Frontend.hierarchyDuplicateNameModalClose')
            }}
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.hierarchyDuplicateNameModalRename'),
                onClick: onRename
            }}
            closeButton={true}
        >
            <div className='hierarchy-error-content'>
                <p>
                    {translate('ABB.Powertrain.Frontend.hierarchyDuplicateNameModalContent')}
                </p>
            </div>
        </GeneralDialog>
    );
};

HierarchyDuplicateNameModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onRename: PropTypes.func.isRequired
};

export default HierarchyDuplicateNameModal;
